import { img, useGet } from "../../lib/api";

const BannerImage = ({ b }) => (
  <div className="relative overflow-hidden rounded-2xl">
    <img src={img(b.image_url)} alt={b.title || "Banner event"} className="h-52 w-full object-cover sm:h-72 md:h-96" />
    {b.title && (
      <div className="absolute inset-0 flex items-center bg-gradient-to-r from-[var(--forest-dark)]/85 via-[var(--forest-dark)]/40 to-transparent px-6 md:px-12">
        <p className="max-w-lg font-display text-xl font-semibold text-white sm:text-2xl md:text-3xl" data-testid="event-banner-title">{b.title}</p>
      </div>
    )}
  </div>
);

export const EventBanner = () => {
  const { data } = useGet("banners-active", "/banners/active");
  const b = data?.[0];
  if (!b) return null;
  return (
    <section className="mx-auto max-w-7xl px-5 pt-5 lg:px-8" data-testid="event-banner">
      {b.link_url ? (
        <a href={b.link_url} className="block transition-opacity hover:opacity-95" data-testid="event-banner-link"><BannerImage b={b} /></a>
      ) : (
        <BannerImage b={b} />
      )}
    </section>
  );
};
